export default "__VITE_ASSET__581834c9__";